import Button from "../../gui/Button/Button"
import IconButton from "../../gui/Button/IconButton"
import CopyIcon from "../../gui/Icons/CopyIcon"
import { useOverlay } from "../../gui/Overlay/OverlayProvider"
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider"
import TextInput from "../../gui/TextInput/TextInput"
import Utils from "../../libs/Utils"

const DIALOG_ID="share"

function ShareDlg(props:{url:string}) {
    const {popOverlay} = useOverlay()
    const {addSnackbar} = useSnackbar()
    const onCopy = () => { Utils.clipboard(props.url); addSnackbar("Copied to clipboard", undefined, "info") }
    const onClose = () => popOverlay(DIALOG_ID)
    const onEmail = () => window.open(`mailto:?body=${encodeURIComponent(props.url)}`)
    return <>
        <h2>Share</h2>
        <div className="content">
            <div className="flex middle gap-8">
                <TextInput className="flex1" readOnly defaultValue={props.url}/>
                <IconButton size="medium" onClick={onCopy}><CopyIcon/></IconButton>
            </div>
        </div>
        <div className="actions">
            <Button size="medium" onClick={onClose}>Cancel</Button>
            <Button size="medium" onClick={onEmail}>Email</Button>
        </div>
    </>
}
export default function useShareDlg(){
    const {addOverlay,hasOverlay} = useOverlay()
    const _share = (url:string) => {
        if (hasOverlay(DIALOG_ID)) return
        else addOverlay(DIALOG_ID, {children:<ShareDlg url={url}/>, className:"dialog"})
    }
    const showShare = (url:string) => {
        if (!!navigator.share)  navigator.share({url}).catch(e => _share(url))
        else _share(url)
    }
    return {showShare}
}